<template>
  <div class="pb-6 mt-auto">
    <div class="pb-6">
      <Separator no-margin />
    </div>
    <div class="px-6">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import Separator from '@/components/separator/Separator.vue'
</script>
